import type SVGType from 'types/svg.types';

const WalletPercentIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.7416 9.0401H6.58835C5.47867 9.0401 4.5791 8.14053 4.5791 7.03085M15.7416 9.0401H17.5276C18.514 9.0401 19.3136 9.83972 19.3136 10.8261V17.5236C19.3136 18.51 18.514 19.3096 17.5276 19.3096H12.1696M15.7416 9.0401V5.88834C15.7416 5.16306 15.1536 4.5751 14.4284 4.5751H7.03485C5.67858 4.5751 4.5791 5.67458 4.5791 7.03085M4.5791 11.2726V7.03085"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9.2998 14.4198L4.2998 19.4198"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <ellipse cx="8.55957" cy="19.1198" rx="0.875" ry="0.87499" fill="#351A4D" />
    <ellipse cx="5.04004" cy="14.7198" rx="0.875" ry="0.87499" fill="#351A4D" />
  </svg>
);

export default WalletPercentIcon;
